var v = Object.defineProperty;
var u = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var p = (r, e, n) => e in r ? v(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n, f = (r, e) => {
  for (var n in e || (e = {}))
    y.call(e, n) && p(r, n, e[n]);
  if (u)
    for (var n of u(e))
      x.call(e, n) && p(r, n, e[n]);
  return r;
};
var i = (r, e, n) => p(r, typeof e != "symbol" ? e + "" : e, n);
function a(...r) {
  var e;
  typeof window != "undefined" && ((e = window.OFFSET) != null && e.debug) && console.log("[offset-consent]", ...r);
}
const w = [
  {
    id: "analytics",
    name: "Analytics",
    desc: "Helps us understand how the site is used."
  },
  {
    id: "marketing",
    name: "Marketing Messaging",
    desc: "Powers chat, email, and SMS, and shares your activity to tailer experiences to you."
  }
], k = {
  title: "Your privacy",
  body: 'We use cookies and services to enhance your experience, analyze traffic, and personalize content. You can choose which you want to allow. For more information, please see our <a href="/privacy/" data-toggle="modal" data-target="#figureModalMed" role="link" aria-label="View Privacy Policy">Privacy Policy</a>.',
  acceptAll: "Accept all",
  rejectAll: "Reject non-essential",
  manage: "Manage",
  save: "Save choices",
  reopen: "Privacy settings"
};
class $ {
  constructor(e) {
    i(this, "version");
    i(this, "categories");
    i(this, "cookieName");
    i(this, "cookieDays");
    i(this, "gpcAutoDeny");
    i(this, "showReopenButton");
    i(this, "copy");
    var n, o, t, c, s;
    this.version = e.version, this.categories = (n = e.categories) != null ? n : w, this.cookieName = (o = e.cookieName) != null ? o : "offset_consent", this.cookieDays = (t = e.cookieDays) != null ? t : 180, this.gpcAutoDeny = (c = e.gpcAutoDeny) != null ? c : !0, this.showReopenButton = (s = e.showReopenButton) != null ? s : !1, this.copy = f(f({}, k), e.copy), a("initialized", {
      version: this.version,
      categories: this.categories.map((d) => d.id),
      cookieName: this.cookieName,
      cookieDays: this.cookieDays,
      gpcAutoDeny: this.gpcAutoDeny,
      showReopenButton: this.showReopenButton
    });
  }
  readState() {
    try {
      const e = this.readCookie(this.cookieName);
      if (!e)
        return a("readState: no consent cookie found"), null;
      const n = JSON.parse(e);
      return n.version !== this.version ? (a(
        `readState: stored version "${n.version}" does not match current version "${this.version}", discarding`
      ), null) : (a("readState: found valid record", n), n);
    } catch (e) {
      return a("readState: failed to parse consent cookie", e), null;
    }
  }
  persist(e, n) {
    const o = {
      version: this.version,
      ts: (/* @__PURE__ */ new Date()).toISOString(),
      gpc: this.gpcActive(),
      source: n,
      grants: e,
      ua: navigator.userAgent
    };
    a("persist", o), this.writeCookie(this.cookieName, JSON.stringify(o), this.cookieDays), this.sendLog(o), this.applyGrants(e);
  }
  allGrants(e) {
    return Object.fromEntries(this.categories.map((n) => [n.id, e]));
  }
  applyGrants(e) {
    a("applyGrants", e);
    for (const n of this.categories)
      e[n.id] && this.releaseCategory(n.id);
    window.dispatchEvent(new CustomEvent("offset:consent", { detail: { grants: e } }));
  }
  gpcActive() {
    const e = this.gpcAutoDeny && navigator.globalPrivacyControl === !0;
    return e && a("gpcActive: Global Privacy Control detected"), e;
  }
  reset() {
    a("reset: clearing consent cookie and reloading"), this.writeCookie(this.cookieName, "", -1), location.reload();
  }
  releaseCategory(e) {
    const n = document.querySelectorAll(
      `script[type="text/plain"][data-cc-category="${e}"]`
    );
    a(`releaseCategory: "${e}" — releasing ${n.length} tag(s)`), n.forEach((o) => {
      var c;
      const t = document.createElement("script");
      for (const s of Array.from(o.attributes))
        if (!(s.name === "type" || s.name === "data-cc-category")) {
          if (s.name === "data-src") {
            t.src = s.value;
            continue;
          }
          t.setAttribute(s.name, s.value);
        }
      o.textContent && (t.textContent = o.textContent), (c = o.parentNode) == null || c.replaceChild(t, o);
    });
  }
  sendLog(e) {
    {
      a("sendLog: no LOG_ENDPOINT configured, skipping audit log POST");
      return;
    }
  }
  readCookie(e) {
    var o;
    const n = document.cookie.match("(^|;)\\s*" + e + "\\s*=\\s*([^;]+)");
    return n ? decodeURIComponent((o = n[n.length - 1]) != null ? o : "") : null;
  }
  writeCookie(e, n, o) {
    const t = /* @__PURE__ */ new Date();
    t.setTime(t.getTime() + o * 864e5), document.cookie = `${e}=${encodeURIComponent(n)};expires=${t.toUTCString()};path=/;SameSite=Lax`;
  }
}
const S = `:root {
  --offset-modal-z-index: 9999;
}

#oc-root {
  font-family: var(--offset-font-family-base, system-ui, -apple-system, sans-serif);
}

.oc-banner {
  position: fixed;
  left: 24px;
  right: 24px;
  bottom: 24px;
  z-index: var(--offset-modal-z-index, 9999);
  background: var(--offset-body-bg, #fff);
  color: var(--offset-body-color, #212529);
  border: var(--offset-border-width, 1px) solid var(--offset-border-color, #dee2e6);
  border-radius: var(--offset-border-radius, 0.25rem);
  box-shadow: var(--offset-modal-shadow, 0 2px 20px 0 rgba(0, 0, 0, 0.1));
  padding: 20px 24px;
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1100px;
  margin: 0 auto;
}

.oc-banner-text {
  flex: 1;
  min-width: 260px;
}

.oc-banner-text strong {
  font-size: 15px;
}

.oc-banner-text p {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--offset-gray-600, #6c757d);
}

.oc-banner-btns {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.oc-btn {
  cursor: pointer;
  border-radius: var(--offset-btn-border-radius, var(--offset-border-radius, 0.25rem));
  padding: var(--offset-input-btn-padding-y, 0.5rem) var(--offset-input-btn-padding-x, 0.75rem);
  font-size: var(--offset-input-btn-font-size, 1rem);
  font-family: var(--offset-font-family-base, system-ui, -apple-system, sans-serif);
  line-height: var(--offset-input-btn-line-height, 1.8);
  border: 1px solid;
  transition: opacity 0.15s;
}

.oc-btn:hover {
  opacity: 0.85;
}

.oc-btn-solid {
  background: var(--offset-btn-bg-primary, #007bff);
  color: var(--offset-btn-text-color-primary, #fff);
  border-color: var(--offset-btn-border-primary, var(--offset-btn-bg-primary, #007bff));
}

.oc-btn-ghost {
  background: transparent;
  color: var(--offset-body-color, #212529);
  border-color: var(--offset-border-color, #dee2e6);
}

.oc-btn-full {
  width: 100%;
  margin-top: 8px;
}

.oc-modal {
  position: fixed;
  inset: 0;
  z-index: calc(var(--offset-modal-z-index, 9999) + 1);
  background: var(--offset-overlay-bg, rgba(0, 0, 0, 0.1));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.oc-modal-card {
  background: var(--offset-modal-content-bg, var(--offset-body-bg, #fff));
  color: var(--offset-body-color, #212529);
  max-width: 520px;
  width: 100%;
  border-radius: var(--offset-border-radius, 0.25rem);
  padding: 8px 28px 28px;
  max-height: 85vh;
  max-height: 85dvh;
  overflow: auto;
  box-shadow: var(--offset-modal-shadow, 0 2px 20px 0 rgba(0, 0, 0, 0.1));
}

.oc-modal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 14px;
  border-bottom: 1px solid var(--offset-border-color, #dee2e6);
}

.oc-modal-head strong {
  font-size: 18px;
}

.oc-modal-close {
  background: none;
  border: none;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  color: var(--offset-gray-600, #6c757d);
  padding: 0;
}

.oc-modal-body {
  margin: 14px 0 0;
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--offset-gray-600, #6c757d);
}

.oc-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  padding: 18px 0;
  border-bottom: 1px solid var(--offset-border-color, #dee2e6);
}

.oc-row-name {
  font-size: 14px;
  font-weight: 600;
}

.oc-row-desc {
  font-size: 12.5px;
  color: var(--offset-gray-600, #6c757d);
  margin-top: 3px;
  line-height: 1.5;
}

.oc-row-desc ul {
  margin: 0;
  padding-left: 20px;
}

.oc-row-desc li {
  font-size: 12.5px;
}

.oc-always {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--offset-gray-600, #6c757d);
  white-space: nowrap;
}

.oc-switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  flex: none;
}

.oc-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.oc-slider {
  position: absolute;
  inset: 0;
  background: var(--offset-gray-300, #dee2e6);
  border-radius: 24px;
  transition: 0.2s;
  cursor: pointer;
}

.oc-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background: var(--offset-white, #fff);
  border-radius: 50%;
  transition: 0.2s;
}

.oc-switch input:checked + .oc-slider {
  background: var(--offset-btn-bg-primary, #007bff);
}

.oc-switch input:checked + .oc-slider::before {
  transform: translateX(18px);
}

.oc-reopen {
  position: fixed;
  left: 35px;
  bottom: 35px;
  z-index: calc(var(--offset-modal-z-index, 9999) - 1);
  background: var(--offset-body-bg, #fff);
  color: var(--offset-body-color, #212529);
  border: 1px solid var(--offset-border-color, #dee2e6);
  border-radius: var(--offset-btn-border-radius, var(--offset-border-radius, 0.25rem));
  padding: 6px 11px;
  font-size: 8px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: var(--offset-modal-shadow, 0 2px 20px 0 rgba(0, 0, 0, 0.1));
  font-family: var(--offset-font-family-base, system-ui, -apple-system, sans-serif);
}

@media (max-width: 560px) {
  .oc-banner {
    left: 12px;
    right: 12px;
    bottom: max(12px, env(safe-area-inset-bottom));
    padding: 16px;
    gap: 14px;
  }
  .oc-banner-text {
    min-width: 0;
  }
  .oc-banner-btns {
    width: 100%;
    flex-direction: column;
  }
  .oc-btn {
    flex: 1;
    width: 100%;
    padding: 0.65rem 0.75rem;
  }
  .oc-modal {
    padding: 0;
    align-items: flex-end;
  }
  .oc-modal-card {
    max-width: 100%;
    max-height: 90vh;
    max-height: 90dvh;
    border-radius: var(--offset-border-radius, 0.25rem)
      var(--offset-border-radius, 0.25rem) 0 0;
    padding: 8px 18px calc(18px + env(safe-area-inset-bottom));
  }
  .oc-modal-head {
    padding: 16px 0 12px;
  }
  .oc-row {
    padding: 14px 0;
    gap: 12px;
  }
  .oc-reopen {
    left: 16px;
    bottom: max(16px, env(safe-area-inset-bottom));
  }
}
`;
function A() {
  return `<style>${S}</style>`;
}
class z {
  constructor(e) {
    i(this, "manager");
    i(this, "root", null);
    i(this, "banner", null);
    i(this, "modal", null);
    i(this, "reopen", null);
    this.manager = e;
  }
  mount() {
    var o, t, c, s, d, h;
    if (this.root) return;
    const e = document.createElement("div");
    e.id = "oc-root", e.innerHTML = A() + this.buildBanner() + this.buildModal() + this.buildReopenBtn(), document.body.appendChild(e), this.root = e, this.banner = e.querySelector("#oc-banner"), this.modal = e.querySelector("#oc-modal"), this.reopen = e.querySelector("#oc-reopen"), (o = e.querySelector("#oc-accept")) == null || o.addEventListener("click", () => {
      this.manager.persist(this.manager.allGrants(!0), "accept_all"), this.hideAll();
    }), (t = e.querySelector("#oc-reject")) == null || t.addEventListener("click", () => {
      this.manager.persist(this.manager.allGrants(!1), "reject_all"), this.hideAll();
    }), (c = e.querySelector("#oc-manage")) == null || c.addEventListener("click", () => this.openModal()), (s = e.querySelector("#oc-reopen")) == null || s.addEventListener("click", () => this.openModal()), (d = e.querySelector("#oc-modal-close")) == null || d.addEventListener("click", () => this.closeModal()), (h = e.querySelector("#oc-modal-save")) == null || h.addEventListener("click", () => {
      var g;
      const m = {};
      for (const b of this.manager.categories) {
        const l = e.querySelector(
          `#oc-tog-${b.id}`
        );
        m[b.id] = (g = l == null ? void 0 : l.checked) != null ? g : !1;
      }
      this.manager.persist(m, "managed"), this.hideAll();
    });
    const n = this.manager.readState();
    if (n) {
      a("mount: existing consent record found, applying grants and skipping banner"), this.manager.applyGrants(n.grants), this.reopen && (this.reopen.hidden = !1);
      return;
    }
    this.manager.gpcActive() && (a("mount: GPC active, auto-denying all categories (banner still shown)"), this.manager.persist(this.manager.allGrants(!1), "gpc")), a("mount: no prior decision, showing banner"), this.banner && (this.banner.hidden = !1);
  }
  open() {
    this.modal && this.openModal();
  }
  openModal() {
    var n, o;
    a("openModal");
    const e = this.manager.readState();
    for (const t of this.manager.categories) {
      const c = (n = this.modal) == null ? void 0 : n.querySelector(
        `#oc-tog-${t.id}`
      );
      c && (c.checked = (o = e == null ? void 0 : e.grants[t.id]) != null ? o : !1);
    }
    this.banner && (this.banner.hidden = !0), this.modal && (this.modal.hidden = !1);
  }
  closeModal() {
    a("closeModal"), this.modal && (this.modal.hidden = !0), this.manager.readState() ? this.reopen && (this.reopen.hidden = !1) : this.banner && (this.banner.hidden = !1);
  }
  hideAll() {
    this.banner && (this.banner.hidden = !0), this.modal && (this.modal.hidden = !0), this.reopen && (this.reopen.hidden = !1);
  }
  buildBanner() {
    const { copy: e } = this.manager;
    return `<div id="oc-banner" class="oc-banner" role="dialog" aria-live="polite" hidden>
  <div class="oc-banner-text">
    <strong>${e.title}</strong>
    <p>${e.body}</p>
  </div>
  <div class="oc-banner-btns">
    <button id="oc-manage" class="oc-btn oc-btn-ghost">${e.manage}</button>
    <button id="oc-reject" class="oc-btn oc-btn-ghost">${e.rejectAll}</button>
    <button id="oc-accept" class="oc-btn oc-btn-solid">${e.acceptAll}</button>
  </div>
</div>`;
  }
  buildModal() {
    const { copy: e, categories: n } = this.manager, o = n.map(
      (t) => `
  <div class="oc-row">
    <div>
      <div class="oc-row-name">${t.name}</div>
      <div class="oc-row-desc">${t.desc}</div>
    </div>
    <label class="oc-switch" aria-label="Toggle ${t.name}">
      <input type="checkbox" id="oc-tog-${t.id}">
      <span class="oc-slider"></span>
    </label>
  </div>`
    ).join("");
    return `<div id="oc-modal" class="oc-modal" hidden>
  <div class="oc-modal-card" role="dialog" aria-modal="true" aria-label="${e.title}">
    <div class="oc-modal-head">
      <strong>${e.title}</strong>
      <button id="oc-modal-close" class="oc-modal-close" aria-label="Close">&times;</button>
    </div>
    <p class="oc-modal-body">${e.body}</p>
    <div class="oc-row">
      <div>
        <div class="oc-row-name">Strictly necessary</div>
        <div class="oc-row-desc">Required for the site to function.<br/>
			<ul>
				<li>Offset Commerce (cms, commerce and payment processing)</li>
				<li>Stripe.js (payment processing and fraud detection)</li>
				<li>reCAPTCHA (form security/anti-spam)</li>
				<li>FontAwesome (UI dependency)</li>
				<li>accessiBe (accessibility widget used when applicable)</li>
			</ul>
		</div>
      </div>
      <span class="oc-always">Always on</span>
    </div>
    ${o}
    <button id="oc-modal-save" class="oc-btn oc-btn-solid oc-btn-full">${e.save}</button>
  </div>
</div>`;
  }
  buildReopenBtn() {
    return this.manager.showReopenButton ? `<button id="oc-reopen" class="oc-reopen" hidden>${this.manager.copy.reopen}</button>` : "";
  }
}
export {
  $ as ConsentManager,
  z as ConsentUI
};
